import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';

export function useRouteQuery(key: string, defaultValue = '') {
  const route = useRoute();
  const router = useRouter();

  const routerValue = computed(() =>
    route.query[key] ? (route.query[key] as string) : defaultValue,
  );

  const setValue = (newValue: string | undefined) =>
    router.push({ query: { ...route.query, [key]: newValue } });

  return { routerValue, setValue };
}
